export async function OnCompletedLoadPage() {
    const plugin = document.createElement("script");
    plugin.setAttribute(
        "src",
        process.env.BASE_URL + 'Content/js/functions.js'
    );
    plugin.async = true;
    document.head.appendChild(plugin);

    $(".program-carousel").owlCarousel({
        dots: true,
        rtl: true,
        margin: 20,
        stagePadding: 0,
        merge: false,
        rewind: false,
        startPosition: 0,
        slideBy: 1,
        center: false,
        lazyLoad: false,
        nav: true,
        navText: ['<i class="icon-angle-left"></i>', '<i class="icon-angle-right"></i>'],
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        smartSpeed: 250,
        fluidSpeed: 250,
        video: false,
        animateIn: false,
        animateOut: false,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            },
        },
        autoplay: true,
        loop: false
    });
}

export async function getAllPrograms(para) {
    para.$HttpClient.commonService.url = "Programs/GetAllPrograms";
    //para.contactUsURL = 'https://scfhs.org.sa/ar/tawasul';
    //para.applicantURL = 'https://ha.edu.sa/Applicant';
    //para.loadFileHeader();
    //para.loadFileFooter();

    para.$HttpClient.commonService.get()
        .then(r => r.json())
        .then(json => {
           debugger
            para.programs = json.model;
            para.contactUsURL = json.contactUsURL;
            para.applicantURL = json.applicantURL;
            para.loadFileHeader();
            para.loadFileFooter();
        });
  
}
export async function getExternalURL(para) {
    debugger
    para.$HttpClient.commonService.url = "Programs/GetExternalLink";

    para.$HttpClient.commonService.get()
        .then(r => r.json())
        .then(json => {
            debugger
            para.contactUsURL = json.contactUsURL;
            para.applicantURL = json.applicantURL;

        });
}
export async function getHeaderHtml(paraHeader) {
    debugger
    var htmlpathHeader = "";
    if (localStorage.getItem('Public_lang') == 'en-us') {
        htmlpathHeader = process.env.BASE_URL + 'Content/HTMLFiles/HomePage/HomePageHeaderContentEN.html';
    } else {
        htmlpathHeader = process.env.BASE_URL + 'Content/HTMLFiles/HomePage/HomePageHeaderContentAR.html';

    }

    fetch(htmlpathHeader, {
        method: "get"
    })
        .then(r => r.text())
        .then(result => {
            SetHeaderHTML(paraHeader, result).then(function () {
                $("#slider").css("background", `url('${process.env.BASE_URL}Content/images/banner-schfs.jpg') center center;`);
            });
           // paraHeader.htmlHeader = result;
        })
        .catch(error => {
            console.error("error getting file");
        });
}
function SetHeaderHTML(paraHeader, html) {
    return new Promise(resolve => {
        paraHeader.htmlHeader = html;
        $(document).on("click", "#btnRegister", function () {
            paraHeader.$router.push({ name: 'SignUp' })
                });
    });
}
export async function getFooterHtml(paraFooter) {
    debugger
    var htmlpathFooter = "";
    if (localStorage.getItem('Public_lang') == 'en-us') {
        htmlpathFooter = process.env.BASE_URL + 'Content/HTMLFiles/HomePage/HomePageFooterEN.html';
    } else {
        htmlpathFooter = process.env.BASE_URL + 'Content/HTMLFiles/HomePage/HomePageFooterAR.html';

    }

    fetch(htmlpathFooter, {
        method: "get"
    })
        .then(r => r.text())
        .then(result => {
            paraFooter.htmlFooter = result;
            $(document).on("click", "#btnPartner", function () {
                paraFooter.$router.push({ name: 'SignUp' })
            });
        })
        .catch(error => {
            console.error("error getting file");
        });
}

export async function OnChangeLanguage(paraLang) {
    if (localStorage.getItem('Public_lang') == 'en-us') {
        localStorage.setItem('Public_lang', 'ar-sa');
        paraLang.Language = 'English';
    }
    else {
        localStorage.setItem('Public_lang', 'en-us');
        paraLang.Language = 'العربية';
    }
    window.location.reload();
}